import { createSlice } from '@reduxjs/toolkit'
import { ImproveFlows, Nullable } from 'share/types'
import { GetUserResponse } from 'share/types/api/leads'
import { ActiveCreditApplication, UserRecord } from 'share/types/model/user'

import { RootState } from '..'

type InitialState = {
  leadId: Nullable<string>
  isRejected: boolean
  current_flow_id: Nullable<string>
  record: Partial<UserRecord>
  spouse_record: Partial<UserRecord>
  phone: Nullable<string>
  creditApplication: Partial<ActiveCreditApplication>
  improveParamsFlows: Array<ImproveFlows>
}

const initialState: InitialState = {
  leadId: null,
  isRejected: false,
  record: {},
  spouse_record: {},
  current_flow_id: null,
  phone: null,
  creditApplication: {},
  improveParamsFlows: []
}

const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    setUserData: (state, { payload }: { payload: GetUserResponse }) => {
      state.leadId = payload.credit_application.id
      state.current_flow_id = payload.current_flow_id
      state.improveParamsFlows = payload.improve_params_flows
      state.phone = payload.phone
      state.record = payload.record
      state.spouse_record = payload.spouse_record
      state.creditApplication = payload.credit_application
    },
    setLeadId: (state, { payload }: { payload: string | null }) => {
      state.leadId = payload
    },
    setLoanProcessingFlowId: (state, { payload }: { payload: string }) => {
      state.creditApplication.loan_processing_flow_id = {
        id: payload,
        is_done: false
      }
    },
    setIsRejected: (state, { payload }: { payload: boolean }) => {
      state.isRejected = payload
    }
  }
})

export const { setUserData, setLeadId, setLoanProcessingFlowId, setIsRejected } = userSlice.actions

export const getLeadIdSelector = (state: RootState) => state.user.leadId
export const getActiveCreditApplication = (state: RootState) => state.user.creditApplication
export const getUserRecord = (state: RootState) => state.user.record
export const getSpouseRecord = (state: RootState) => state.user.spouse_record
export const getImproveParamsFlows = (state: RootState) => state.user.improveParamsFlows
export const getIsRejectedSelector = (state: RootState) => state.user.isRejected
export const getCurrentFlowId = (state: RootState) => state.user.current_flow_id

export default userSlice.reducer
